import { NO_EPG_ID } from '$/epg/programs'
import { ONE_SECOND_MS } from '@/constants'
import { type EpgInfo, type LiveChannel } from '@setplex/tria-api'
import { subHours } from 'date-fns'
import { formatDateToLabelInfo } from '~/shared/helpers/date'
import {
  MAX_REWIND_BACK_HOURS,
  type LiveProgramInfo,
  type LiveProgramLocalizedInfo,
} from './index.h'

const formatStartTime = ({
  actualStartMs,
  channelEpgId,
}: Readonly<EpgInfo>): number => {
  const start =
    NO_EPG_ID === channelEpgId
      ? subHours(new Date(), MAX_REWIND_BACK_HOURS).getTime()
      : actualStartMs
  return start / ONE_SECOND_MS
}

export const formatToView = ({
  channel,
  program,
}: {
  channel: Readonly<LiveChannel>
  program: Readonly<EpgInfo>
}): LiveProgramInfo => {
  return {
    logoUrl: channel.logo,
    channelId: channel.id,
    channelNumber: channel.number,
    channelTitle: channel.title || '',
    programId: program.id,
    programTitle: program.name,
    description: program.description,
    actualStartMs: program.actualStartMs,
    actualStopMs: program.actualStopMs,
    actualStartSec: program.actualStartSec,
    actualStopSec: program.actualStopSec,
    startTime: formatStartTime(program),
    rating: program.rating,
    isEmpty: program.isEmpty,
  }
}

export const formatToLocalizedViewWithLabels =
  () =>
  (info: LiveProgramInfo): LiveProgramLocalizedInfo => {
    // format duration label
    const duration = formatDateToLabelInfo(
      info.actualStartMs,
      info.actualStopMs
    )
    const labels = [duration, info.rating || '']

    return {
      ...info,
      labels,
    }
  }
